import { useFlattenedFilters } from './useFlattenedFilters';

export const useHasFilters = () => {
  const filters = useFlattenedFilters();

  return filters.length > 0;
};
